/**
 * Created by Andrey Popov on 4/2/25.
 */

const Merge2GeneratorView = cc.Node.extend({
    ctor: function (generator, unitView) {
        this._super();

        this.generator = generator;
        this.unitView = unitView;
        this.visible = false;

        if (this.generator.data.showProgress) {
            this.createProgress();
        }

        this.restoreState();
    },

    restoreState: function (animated) {
        if (this.progress) {
            if (this.generator.mined === 0 || this.generator.isCompleted()) {
                this.hideProgress(animated);
            } else {
                this.showProgress(animated);
            }

            this.updateProgress(animated);
        }

        if (!this.inactiveAnimation) {
            this.createInactiveAnimation();
        }

        if (!this.activeAnimation) {
            this.createActiveAnimation();
        }

        if (!this.energyView) {
            this.createEnergyView();
        }

        this.updateTimer(animated);
        this.updateActive();
        this.updateAmplifier();
        this.updateEnergyFree(animated);
    },

    updateAmplifier: function () {
        const name = this.generator.isAmplified() ? "amplifier" : "animation";

        if (this.activeAnimationName !== name) {
            this.activeAnimationName = name;
            this.activeAnimation.setAnimation(0, name, true);
        }
    },

    getEnergyIdleAnimation: function () {
        if (this.energyFree) {
            return "idle_free";
        }
        return this.active ? "active" : "inactive";
    },

    updateEnergyFree: function (animated) {
        const free = this.generator.isEnergyFree();
        if (!this.energyView || this.energyFree === free) {
            return;
        }
        this.energyFree = free;

        if (!animated) {
            this.energyView.setAnimation(0, this.getEnergyIdleAnimation(), true);
            return;
        }

        if (free) {
            this.energyView.setAnimationAndIdleAfter("change_free", "idle_free");
        } else {
            this.energyRevertPending = true;
            this.energyView.setAnimationAndIdleAfter("revert_free", this.getEnergyIdleAnimation());
        }
    },

    createProgress: function () {
        const styles = cleverapps.styles.Merge2GeneratorView.progress;

        this.progress = new ScaledProgressBar({
            type: styles.type
        });
        this.progress.hidden = false;
        this.unitView.addChild(this.progress);
        this.progress.setAnchorPoint(0.5, 0.5);
        this.progress.setLength(styles.width);
        this.progress.setAlignment(styles);
    },

    updateProgress: function (animated) {
        const total = this.generator.data.spawn;
        this.progress.setGoal(total);
        const current = total - this.generator.mined;
        this.progress.setPercentage(current, {
            animated
        });
    },

    showProgress: function (animated) {
        if (!this.progress.hidden) {
            return;
        }
        this.progress.hidden = false;
        this.progress.stopAllActions();

        if (!animated) {
            this.progress.setVisible(true);
            return;
        }

        const styles = cleverapps.styles.Merge2GeneratorView;

        this.progress.setPositionY(this.progress.y + styles.progress.moveByY);
        this.progress.setScale(0.5);
        this.progress.setVisible(true);

        this.progress.runAction(new cc.Spawn(
            new cc.MoveBy(0.1, 0, -styles.progress.moveByY),
            new cc.ScaleTo(0.1, 1)
        ));
    },

    hideProgress: function () {
        if (this.progress.hidden) {
            return;
        }
        this.progress.hidden = true;
        this.progress.stopAllActions();
        this.progress.setVisible(false);
    },

    updateTimer: function (animated) {
        if (this.generator.isCompleted() && this.generator.isRestoring()) { // || cleverapps.config.debugMode && this.generator.isRestoring()
            this.createTimer(animated);
            this.createSpeedUpButton(animated);
        } else {
            this.removeTimer(animated);
            this.removeSpeedUpButton(animated);
        }
    },

    createTimer: function (animated) {
        if (this.unitView.hasAdditionalView("timer")) {
            return;
        }

        const styles = cleverapps.styles.Merge2GeneratorView.timer;
        const timer = new cleverapps.Spine(bundles.small_timer_merge.jsons.mineable_timer_json);
        timer.setAlignment(styles);

        const animationName = "animation";

        timer.setAnimation(0, animationName, true);

        const animationDuration = timer.getAnimationDuration(animationName) * 1000;
        const total = this.generator.getRestoreCooldown();
        const left = this.generator.getRestoreTimeLeft();

        timer.setTimeScale(animationDuration / total);

        const progress = (total - left) / total;
        timer.setTrackProgress(progress);

        timer.setCompleteListenerOnce(() => {
            this.unitView.removeAdditionalView("timer", false);
        });
        timer.setSafeToRemove();

        this.unitView.createAdditionalView("timer", timer, !animated);
    },

    removeTimer: function (animated) {
        this.unitView.removeAdditionalView("timer", !animated);
    },

    createSpeedUpButton: function (animated) {
        if (this.unitView.hasAdditionalView("speedUpButton")) {
            return;
        }

        const button = new UnitSpeedUpButton(this.generator.getSpeedUpOptions());
        this.unitView.createAdditionalView("speedUpButton", button, !animated);
    },

    removeSpeedUpButton: function (animated) {
        this.unitView.removeAdditionalView("speedUpButton", !animated);
    },

    createInactiveAnimation: function () {
        this.inactiveAnimation = new cleverapps.Spine(bundles.merge.jsons.mineable_inactive_json);
        this.inactiveAnimation.setAlignment(cleverapps.styles.Merge2GeneratorView.inactive);
        this.inactiveAnimation.setAnimation(0, "animation", true);
        this.unitView.addChild(this.inactiveAnimation);
    },

    createActiveAnimation: function () {
        this.activeAnimation = new cleverapps.Spine(bundles.merge_animations.jsons.generator_active_json);
        this.activeAnimation.setAlignment(cleverapps.styles.Merge2GeneratorView.active);
        this.activeAnimationName = "animation";
        this.activeAnimation.setAnimation(0, this.activeAnimationName, true);
        this.unitView.addChild(this.activeAnimation);
    },

    createEnergyView: function () {
        this.energyView = new cleverapps.Spine(bundles.merge.jsons.mineable_energy_json);
        this.energyView.setAlignment(cleverapps.styles.Merge2GeneratorView.energy);
        this.unitView.addChild(this.energyView);
    },

    updateActive: function () {
        if (this.active === this.generator.isActive()) {
            return;
        }

        this.active = this.generator.isActive();

        if (this.active) {
            if (this.unitView.sprite instanceof cleverapps.Spine && this.unitView.sprite.hasAnimation("end_inactive")) {
                this.unitView.sprite.setAnimation(0, "end_inactive", false);
                this.unitView.sprite.setCompleteListenerOnce(() => {
                    this.unitView.sprite.setAnimation(0, "idle", true);
                });
            } else {
                cleverapps.UI.convertToGrayScale(this.unitView.sprite, true);
            }

            if (this.energyView && !this.energyFree) {
                if (!this.energyView.wasShown && this.energyView.hasAnimation("showup")) {
                    this.energyView.wasShown = true;
                    this.energyView.setAnimationAndIdleAfter("showup", "active");
                } else {
                    this.energyView.setAnimation(0, "active", true);
                }
            }

            this.inactiveAnimation.setVisible(false);
            this.activeAnimation.setVisible(true);
        } else {
            if (this.unitView.sprite instanceof cleverapps.Spine && this.unitView.sprite.hasAnimation("start_inactive")) {
                this.unitView.sprite.setAnimationAndIdleAfter("start_inactive", "inactive");
            } else {
                cleverapps.UI.convertToGrayScale(this.unitView.sprite);
            }

            this.inactiveAnimation.setVisible(true);
            this.activeAnimation.setVisible(false);

            if (this.energyView && !this.energyFree) {
                this.energyView.setAnimation(0, "inactive", true);
            }

            if (this.energyHoverHandler) {
                this.energyHoverHandler.remove();
                this.energyHoverHandler = undefined;
            }
        }
    },

    setDimmingDisabled: function (disabled) {
        if (this.active) {
            return;
        }

        const sprite = this.unitView.sprite;
        if (sprite instanceof cleverapps.Spine && sprite.hasAnimation("inactive")) {
            sprite.setAnimation(0, disabled ? "idle" : "inactive", true);
        } else {
            cleverapps.UI.convertToGrayScale(sprite, disabled);
        }
    },

    completeMine: function () {
        this.unitView.stopAllActions();

        const basePosition = this.unitView.getPosition();
        const baseScale = this.unitView.getScale();
        this.unitView.squeezeAction = this.unitView.runAction(StandartAnimations.squeeze(this.unitView, { dScale: 0.15 })).setFinalize(() => {
            if (!Merge2.current) {
                return;
            }

            this.unitView.setScale(baseScale);
            this.unitView.setPosition(basePosition);

            if (this.unitView.sprite instanceof cleverapps.Spine) {
                this.unitView.sprite.setAnimation(0, !this.generator.isActive() && this.unitView.sprite.hasAnimation("inactive") ? "inactive" : "idle", true);
            }
        });

        if (this.energyRevertPending) {
            this.energyRevertPending = false;
        } else if (this.energyView) {
            let idle = "inactive";
            if (this.energyFree) {
                idle = "idle_free";
            } else if (this.generator.isActive()) {
                idle = "hover";
            }
            this.energyView.setAnimationAndIdleAfter("click", idle);
        }
    },

    onReduceCooldown: function () {
        this.removeTimer();
        this.removeSpeedUpButton(true);

        const animation = new cleverapps.Spine(bundles.merge.jsons.speedup_animation);
        animation.setPosition(this.unitView.width / 2, this.unitView.height / 2);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();
        this.unitView.addChild(animation);
    },

    onSpeedUp: function (callback) {
        const animation = new cleverapps.Spine(bundles.merge.jsons.speedup_animation);
        animation.setPosition(this.unitView.width / 2, this.unitView.height / 2);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove(callback);
        this.unitView.addChild(animation);

        this.unitView.stopAllActions();
        const basePosition = this.unitView.getPosition();
        const baseScale = this.unitView.getScale();
        this.unitView.runAction(StandartAnimations.jump({ prepareDuration: 0 })).setFinalize(() => {
            this.unitView.setScale(baseScale);
            this.unitView.setPosition(basePosition);
        });
    }
});

cleverapps.styles.Merge2GeneratorView = {
    progress: {
        type: ScaledProgressBar.Types.blue_small,
        moveByY: 15,

        width: 65,
        x: { align: "center" },
        y: { align: "bottom", dy: 1 }
    },

    energy: {
        x: { align: "right", dx: -5 },
        y: { align: "top" }
    },

    inactive: {
        x: { align: "center", dx: -50 },
        y: { align: "top", dy: 10 }
    },

    active: {
        x: { align: "center" },
        y: { align: "top" }
    },

    timer: {
        x: { align: "right" },
        y: { align: "top" }
    },

    deltaAnimation: {
        y: 110
    }
};
